<template>
  <div class="container12" >
    <!--<van-uploader v-model="images" :deletable="canEdit" :disabled="!canEdit" :preview-size="clientHeight_width/3-10" :after-read="afterReadOne" :before-delete="deleteone">-->
    <!--</van-uploader>-->

    <el-upload
      action="#"
      list-type="picture-card"
      :file-list="images"
      :on-preview="handlePictureCardPreview"
      :before-upload="beforeUpload"
      :http-request="afterReadOne"
      :accept="acceptMime"
      :auto-upload="true"
      :on-remove="deleteone"
      :disabled="!canEdit"
      :on-change="uploading"
      :class="{hide:hideUpload}"
    :on-exceed="outLimit">
      <i class="el-icon-plus"></i>
    </el-upload>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
  import { Uploader } from 'vant';
  import { Loading } from 'element-ui';
  import "regenerator-runtime/runtime";

  export default {
    name: "ImgUploaderOne",
    model:{
      prop:'files'
    },
    props:{
      files:{
        type:Array,
        default: ()=>([]) //file对象的三个状态 uploading,done,failed
      },
      fileType:{
        type:String,
        default:''
      },
      limit:{
        type:Number,
        default:10,
      },
      initFlag:{
        type:Number,
        default:0,
      },
      canEdit:{
        type:Boolean,
        default:true
      }
    },
    components:{
      [Uploader.name]:Uploader,
    },
    data(){
      return{
        clientHeight_width:document.body.clientWidth-50,
        images:[],
        dialogImageUrl: '',
        dialogVisible: false,
        hideUpload:false,
          // 允许的 MIME 类型列表
          allowedMimeTypes: [
              'image/jpeg',
              'image/png'
          ],
          // 允许的文件扩展名列表
          allowedExtensions: ['.jpg', '.jpeg', '.png'],
          // 浏览器文件选择器过滤
          acceptMime: 'image/jpeg, image/png',

      }
    },
    watch: {
      initFlag(nv){
        if(nv !=0){
          this.loadImg();
        }
      },
      files(nv) {
        // this.loadImg();
      },
    },
    created() {

    },
    mounted(){
      this.loadImg();
    },
    methods:{

      loadImg(){
        if(this.files && this.files.length>0){
          this.images=[];
          for(var j = 0,len=this.files.length;j < len; j++) {
            if(this.files[j]!='' && this.files[j]!='-1'){
            var imgUrl=this.getImg(this.files[j]);
            var tt={ url: imgUrl, isImage: true,raw:{attrId:this.files[j]}}
            this.images.push(tt);
            }else{
              this.files.splice(0,1)

            }
          }
          this.hideUpload = this.images.length>=this.limit
        }
      },
      uploading(file, fileList){
        // console.log(file);
        // console.log(fileList);
      },
      outLimit(){
        this.$message({
          message: '本类型最多上传【'+this.limit+'】个资料',
          type: 'success',
          offset:250,
          duration:2500,
        });
      },
      handleRemove(file, fileList) {
        console.log(file, fileList);
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      getImg(imgId){
        var dd=this.$util.req.getshowImg(imgId);
        return dd;
      },
      deleteone(file){
        if(file){
          this.files.splice(0,1)
          this.hideUpload = false
        }
        return true;
      },

            beforeUpload(file) {
            // 验证 MIME 类型
            const isAllowedMime = this.allowedMimeTypes.includes(file.type)
            // 验证文件扩展名（兼容浏览器 MIME 识别不一致的情况）
            const fileName = file.name.toLowerCase()
            const hasAllowedExtension = this.allowedExtensions.some(ext =>
                fileName.endsWith(ext)
            )

            // 双重验证策略
            if (!(isAllowedMime || hasAllowedExtension)) {
                this.$message.error('仅支持 JPG/JPEG/PNG 格式的图片!')
                return false
            }

            // 可选：添加文件大小限制（示例限制 2MB）
            const isLt2M = file.size / 1024 / 1024 < 2
            if (!isLt2M) {
                this.$message.error('图片大小不能超过 2MB!')
                return false
            }
               // if (this.verifyFileHeader(file)) {
               //     // this.$refs.upload.submit(); // 手动提交
               // }
               return true;
        },
        verifyFileHeader(file) {
            return new Promise((resolve) => {
                const reader = new FileReader();
                reader.onload = (e) => {
                    try {
                        const buffer = new Uint8Array(e.target.result);
                        const hexHeader = Array.from(buffer.slice(0, 8)) // 读取前8字节
                            .map(b => b.toString(16).padStart(2, '0'))
                            .join('');

                        // 完整格式校验
                        const isJpeg = hexHeader.startsWith('ffd8ffe0'); // JFIF 格式
                        const isPng = hexHeader.startsWith('89504e470d0a1a0a');
                        const isBmp = hexHeader.startsWith('424d');

                        resolve(isJpeg || isPng || isBmp);
                    } catch (error) {
                        console.error('文件头解析失败', error);
                        resolve(false); // 异常时返回 false
                    }
                };
                reader.onerror = () => resolve(false); // 文件读取错误
                reader.readAsArrayBuffer(file.slice(0, 8)); // 仅读取必要数据
            });
        },
      afterReadOne(files){

        if(files){
          let loadingInstance = Loading.service({ fullscreen: true });
          files.status = 'uploading';
          files.message = '上传中...';
          files.type=this.fileType;
          files.attrName=this.$util.uuid.uuid2();
          this.compressImg(files);
          // this.afterReadFile(files);
          loadingInstance.close()
        }
      },
      compressImg(file) {
        var t=this;
        if(/\/(?:jpeg|png)/i.test(file.file.type)&&file.file.size>15000000) {
          this.photoCompress(file,{
            quality: 0.5
          },function (base64Codes) {
            var bl = t.convertBase64UrlToBlob(base64Codes);
            let bytes=atob(base64Codes.split(',')[1]);        //去掉url的头，并转换为byte
            //处理异常,将ascii码小于0的转换为大于0
            let ab = new ArrayBuffer(bytes.length);
            let ia = new Uint8Array(ab);
            for (let i = 0; i < bytes.length; i++) {
              ia[i] = bytes.charCodeAt(i);
            }
            let fileItem = new File([ab],new Date().getTime()+'.jpg',{type:'image/jpg'});
            if(fileItem){
              file.file=fileItem;
              t.afterReadFile(file);
            }
          })
        }else{
          this.afterReadFile(file);
        }
      },
      photoCompress(file, objCompressed, objDiv){
        var ready=new FileReader();
        ready.readAsDataURL(file.file);
        var tt=this;
        ready.onload=function(){
          var fileResult=this.result;
          tt.canvasDataURL(fileResult,objCompressed,objDiv)
        }
      },
      canvasDataURL(path, objCompressed, callback) {
        var img = new Image();
        img.src = path;
        img.onload = function () {
          var that = this;
          //默认压缩后图片规格
          var quality = 0.5;
          var w = that.width;
          var h = that.height;
          var scale = w / h;
          //实际要求
          w = objCompressed.width || w;
          h = objCompressed.height || (w / scale);
          if(objCompressed.quality && objCompressed.quality > 0 && objCompressed.quality <= 1){
            quality = objCompressed.quality;
          }
          //生成canvas
          var canvas = document.createElement('canvas');
          var ctx = canvas.getContext('2d');
          // 创建属性节点
          var anw = document.createAttribute("width");
          anw.nodeValue = w;
          var anh = document.createAttribute("height");
          anh.nodeValue = h;
          canvas.setAttributeNode(anw);
          canvas.setAttributeNode(anh);
          ctx.drawImage(that, 0, 0, w, h);

          var base64 = canvas.toDataURL('image/jpeg', quality);
          // 回调函数返回base64的值
          callback(base64);
        }
      },
      convertBase64UrlToBlob(urlData) {
        var arr = urlData.split(','), mime = arr[0].match(/:(.*?);/)[1], bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
        while(n--){
          u8arr[n] = bstr.charCodeAt(n);
        }
        return new Blob([u8arr], {type:mime});
      },

      afterReadFile(file){
        file.status='uploading';
        let formData = new FormData;
        formData.append('_sk','app');
        formData.append('upload',file.file);
        formData.append('type',file.type);
        formData.append('attachName',this.$util.uuid.uuid2());
        var ttt=this;
        this.$https.postFile('attach/upload.do',formData,(response)=>{
          if (response.status===200&&response.data.isOk){
            // file.attachId=response.data.bean.attach_id;
            ttt.files.splice(0,1)
            ttt.files.push(response.data.bean.attach_id);
            file.file.attrId=response.data.bean.attach_id;
            file.status='done'
            ttt.hideUpload = true
          }else {
            file.status='failed';
          }
        });
        //重新验证表单项
        // this.$refs['photo'].resetValidation();
      },
      closePreview(){
        if (this.onCloseImg){
          this.onCloseImg();
        }
      },
      //预览图片
      //删除照片
      delImg(index){
        this.files.splice(index,1);
      },
    }
  }
</script>

<style >
  .container12{
    width: 100%;
    float: left;
    /*display: flex;*/
    /*flex-direction: row;*/
  }
  .container12 .delete-icon{
    background-color: rgba(0, 0, 0, 0.61);
    width: 20px;
    height: 20px;
    right: 0px;
    position: absolute;
    display: flex;
    justify-content: center;
    align-content: center;
    z-index: 15;
  }
  .container12 .img-div{
    float: left;
    position: relative;
    width: 80px;
    height: 80px;
    margin-right: 4px;
    margin-bottom: 2px;
  }
  .container12 .add-photo{
    float: left;
    background-color: rgb(227, 227, 227);
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .container12 .img-mask{
    background-color: rgba(0, 0, 0,0.61);
    width: 100%;
    height: 100%;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10;
  }
  .container12 .loading{
    color: white;
  }
  .container12 .hide .el-upload--picture-card {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/ImgUploaderOne.vue